<template>
    <li class="au-dotted-list-line">
        <label class="au-dotted-list-line__label">
            <slot name="left"></slot>
        </label>
        <label class="au-dotted-list-line__value">
            <slot name="right"></slot>
        </label>
    </li>
</template>

<script setup>

</script>

<style>
.au-dotted-list-line {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
    font-size: .875rem;
    text-transform: uppercase;
}

.au-dotted-list-line__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.au-dotted-list-line__label:after {
  content: " ........................................................................................................................................................................................................................................................................................."
}

.au-dotted-list-line__value {
    flex-shrink: 0;
}
</style>